export default {
  USER_LOGGED_IN: 'User logged in',
  USER_RELOGGED_IN: {
    name: 'User relogged in',
    required: ['organizationId']
  },
  ORGANIZATION_CHANGED: 'Organization changed',
  BACK_TO_NEW_UI: 'Back to new ui'
};
